import { FC, useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import {
  ExpandedTable,
  IButton,
  Layout,
  SearchFormField,
  StoredPagination,
  ITooltip,
} from "../../ui-kit";
import { Tag } from "antd";
import { PlusIco, TrashIco } from "../../assets/customIcons";
import rolesStore from "../../store/roles";

import RoleForm from "./form/role";
import Paths from "../../constants/PathsBreadcrumbs";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";
import { useHandleForm } from "../../hooks/useHandleForm";
import { useSearch } from "../../hooks/useSearch";

import styles from "./Roles.module.scss";
import { useStatusMessage } from "../../hooks/useStatusMessage";
import Constants from "../../constants/Common";

const Roles: FC = observer(() => {
  const {
    titleIcons: { trash },
  } = Constants;
  const {
    rolesIsLoading,
    getRolesList,
    search,
    paginator,
    roleParamsRowKeys,
    deleteRole,
    rolesData,
    isShowAddForm,
  } = rolesStore;

  useEffect(() => {
    getRolesList();
  }, [paginator.page, paginator.perPage, search.search.text]);

  const deleteData = (e, id) => {
    e.stopPropagation();

    deleteRole(id);
  };

  useBreadcrumbs(Paths.adminRoles);

  useStatusMessage(rolesStore.roleStateStatus);

  const columns = [
    {
      title: "Наименование",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Количество пользователей",
      dataIndex: "userCount",
      key: "userCount",
    },
    {
      title: "Статус",
      dataIndex: "state",
      key: "state",
      render: (_, record) =>
        record?.isDeleted ? (
          <Tag color="red">Удалена</Tag>
        ) : (
          <Tag color="green">Активна</Tag>
        ),
    },
    {
      title: " ",
      key: "delete",
      render: (text, record, index) => (
        <ITooltip title={trash} placement="right">
          <TrashIco
            onClick={(e) => {
              console.log("Delete role");
              deleteData(e, record.id);
            }}
          />
        </ITooltip>
      ),
      className: "delete-cell",
    },
  ];

  const searchForm = useHandleForm(null, { text: "" }, { text: false });
  const {
    handleOnClear: handleClearSearch,
    handleOnChange: handleChangeSearch,
    onFindClick,
  } = useSearch({
    search: search,
    delay: 1000,
    searchForm: searchForm,
    searchKey: "text",
    onFindAction: getRolesList,
  });

  return (
    <Layout>
      <SearchFormField
        className={styles.RolesSearch}
        name="searchText"
        label="Поиск"
        type="text"
        value={searchForm.watchAllField.searchText}
        isFocused={searchForm.isFocused.searchText}
        onFocus={searchForm.handleFocus}
        onBlur={searchForm.handleBlur}
        onChange={handleChangeSearch}
        onClear={handleClearSearch}
        onFindClick={onFindClick}
      />
      <ExpandedTable
        loading={rolesIsLoading.value}
        rowKeys={roleParamsRowKeys.keys}
        setRowKeys={roleParamsRowKeys.setKeys}
        columns={columns}
        data={rolesData}
        className={styles.RolesTable}
        rowExpandable={(record) => !record?.isDeleted}
      >
        <RoleForm />
      </ExpandedTable>
      <StoredPagination {...rolesStore.paginator} />
      <IButton
        size="medium"
        onClick={() => isShowAddForm.toggle()}
        className={styles.RolesAddButton}
      >
        <PlusIco /> {isShowAddForm.value ? "Закрыть форму" : "Добавить роль"}
      </IButton>
      {isShowAddForm.value && <RoleForm />}
    </Layout>
  );
});

export default Roles;
